export const inboxTemplatesConstants = {
    INBOX_TEMPLATES_SUCCESS: 'INBOX_TEMPLATES_SUCCESS',
    INBOX_TEMPLATES_REQUEST: 'INBOX_TEMPLATES_REQUEST',
    INBOX_TEMPLATES_ERROR: 'INBOX_TEMPLATES_ERROR',
    INBOX_ALL_ACTIVE_TEMPLATES_SUCCESS: 'INBOX_ALL_ACTIVE_TEMPLATES_SUCCESS',
};
